<template>
    <div>
        <div class="lds-ring absolute inset-0">
            <div :style="tick"></div>
            <div :style="tick"></div>
            <div :style="tick"></div>
            <div :style="tick"></div>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';

@Options({
    name: 'Spinner',
    props: {
        tickness: {
            type: Number,
            default: 3
        }
    }
})
export default class Spinner extends Vue {
    tickness!: string

    get tick() {
        return {
            borderWidth: `${this.tickness}px`
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.lds-ring {
  display: inline-block;
  width: 100%;
  height: 100%;
}

.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  border-style: solid;
  border-color: var(--orange) transparent transparent transparent;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
}

.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>
